module.exports = __webpack_public_path__ + "teqbahn-assets/media/O_photo.f4e49f08.jpg";